const ExchangeData = [
    {
        name: 'egg',
        value: 'EGG',
        currency: 'USD',
        icon: '023-eggs',
    },
    {
        name: 'corn',
        value: 'CORN',
        currency: 'CHF',
        icon: '002-corn',
    },
    {
        name: 'services of sexy farmer (1 hour)',
        value: 'SEXY-FARMER',
        currency: 'VND',
        icon: '111-sexy-farmer',
    },
    {
        name: 'carrot',
        value: 'CARROT',
        currency: 'GGP',
        icon: '011-carrots',
    },
    {
        name: 'hay bale',
        value: 'HAY-BALE',
        currency: 'DKK',
        icon: '100-hay bale',
    },
    {
        name: 'pikachu',
        value: 'PIKACHU',
        currency: 'HRK',
        icon: '115 Pikachu',
    },
    {
        name: 'weather vane',
        value: 'WEATHER-VANE',
        currency: 'MVR',
        icon: '052-weather vane',
    },
    {
        name: 'astro space-monkey',
        value: 'SPACE-MONKEY',
        currency: 'MXN',
        icon: '114 space monkey',
    },
    {
        name: 'PS5',
        value: 'PS5',
        currency: 'IDR',
        icon: '113 PS5',
    },
    {
        name: 'farm lady (not sure what you will get)',
        value: 'FARM-LADY',
        currency: 'IRR',
        icon: '112 farm-lady',
    },
    {
        name: 'sheep',
        value: 'SHEEP',
        currency: 'TZS',
        icon: '016-sheep',
    },
    {
        name: 'chicken',
        value: 'CHICKEN',
        currency: 'CZK',
        icon: '013-chicken',
    },
    {
        name: 'pig',
        value: 'PIG',
        currency: 'MMK',
        icon: '009-pig',
    },
    {
        name: 'cow',
        value: 'COW',
        currency: 'LAK',
        icon: '010-cow',
    },
    {
        name: 'horse',
        value: 'HORSE',
        currency: 'GNF',
        icon: '018-horse',
    },
    {
        name: 'sexy farmer girl',
        value: 'FARMER-GIRL',
        currency: 'UZS',
        icon: '007-farmer-girl',
    },
    {
        name: 'wisdom from an old farmer',
        value: 'FARMER',
        currency: 'SLL',
        icon: '006-farmer',
    },
    {
        name: 'farm',
        value: 'FARM',
        currency: 'VES',
        icon: '005-farm',
    },
    {
        name: 'goose',
        value: 'GOOSE',
        currency: 'KZT',
        icon: '026-goose',
    },
];

export default ExchangeData;
